import axios from "axios";
import { baseURL } from "../utils/URL";

const onInstallModule = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/module/organization`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

const onDeactivate = async ( postData:any ,config: any) => {
    try {
      const response = await axios.patch(`${baseURL}/module/organization/deactivate/${postData.organizationID}`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };
const onRemove = async ( postData:any ,config: any) => {
    try {
      const response = await axios.patch(`${baseURL}/module/organization/remove/${postData.organizationID}`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  const onGetOrgeModules = async ( id:any ,config: any) => {
    try {
      const response = await axios.get(`${baseURL}/module/organization/${id}`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };


  const onGetRedModules = async (config: any) => {
    try {
      const response = await axios.get(`${baseURL}/module`,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

  export{onInstallModule, onRemove, onGetOrgeModules, onDeactivate,onGetRedModules}